// duck/index.js
import authReducer from './reducers';
export { default as authOperations } from './operations';
export default authReducer;